import {
  useDebouncedValue,
  // useMediaQuery,
  useViewportSize,
} from '@mantine/hooks';
import { useNavigationState } from '@store/hookstate';
import { setViewport } from '@store/redux/features/mobile';
import { selectDevice } from '@store/redux/features/mobile/mobileSelectors';
// import { IDeviceTypes } from '@utils/getDevice';
// import mediaQueries from '@styles/mediaQueries';

import { useEffect, useLayoutEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useGetIsMounted } from 'rooks';
import {
  // validateMediaChange,
  syncNavigationState,
  validateViewportChange,
} from './MediaQuerySubscription.utils';

export function MediaQuerySubscription() {
  const device = useSelector(selectDevice());
  // const mobileQuery = mediaQueries.maxWidth(`${mediaQueries.sm}px`);
  // const isMobile = useMediaQuery(mobileQuery, device === 'mobile');
  const navigationState = useNavigationState();
  const dispatch = useDispatch();
  const isMounted = useGetIsMounted();
  const viewport = useViewportSize();
  const [debouncedViewport] = useDebouncedValue(viewport, 250);

  // Body
  const getBody = (): HTMLElement | null => {
    if (typeof document === 'undefined') return null;
    return document.body;
  };
  const bodyRef = useRef(getBody());
  bodyRef.current = getBody();

  // Media change
  // const onMediaChange = (): IDeviceTypes => {
  //   // Don't change from the first device.
  //   // if (isMobile) return 'mobile';
  //   // return 'desktop';
  //   return devices;
  // };

  // Effects
  // Set before anything intially.
  useLayoutEffect(() => {
    bodyRef.current?.setAttribute('data-device', device);
  }, []);

  useEffect(() => {
    if (!isMounted()) return;
    const actualViewport = validateViewportChange(debouncedViewport);
    dispatch(setViewport(actualViewport));
  }, [debouncedViewport]);

  useEffect(() => {
    if (!isMounted()) return;

    // const actualDevices = validateMediaChange(onMediaChange());
    // Sync redux
    // dispatch(setDevice(actualDevices));

    // Sync hookstate
    syncNavigationState(device, navigationState);

    // Run side effects
    bodyRef.current?.setAttribute('data-device', device);
  }, []);

  return null;
}
